import React, {useEffect, useState} from "react";
import {FieldValues, useForm} from "react-hook-form";
import ReCAPTCHA from "react-google-recaptcha";
import '../../Assets/Css/global.css';
import "../../Assets/Css/Pages/Register/form.css";
import {POST} from "../../Hooks/RequestV2";
import {useTranslation} from "react-i18next";
import {ChangeLanguage} from "../LogIn/Form";
import i18n from "i18next";

const voivodeships = [
    "Dolnośląskie",
    "Kujawsko-pomorskie",
    "Lubelskie",
    "Lubuskie",
    "Łódzkie",
    "Małopolskie",
    "Mazowieckie",
    "Opolskie",
    "Podkarpackie",
    "Podlaskie",
    "Pomorskie",
    "Śląskie",
    "Świętokrzyskie",
    "Warmińsko-mazurskie",
    "Wielkopolskie",
    "Zachodniopomorskie"
];

export default function Register(): React.ReactElement {
    const form = useForm();
    const {t} = useTranslation();
    const [captcha, setCaptcha] = useState<boolean>(false);
    const [sendState, setSendState] = useState<boolean>(false);

    useEffect(() => {
        if (captcha){
            form.clearErrors();
        }
    }, [captcha])

    function send(data: FieldValues): void {
        if (captcha){
            POST('/register', data)
                .then((response) => {
                    if (response.ok){
                        setSendState(true);
                    } else {
                        alert('Coś poszło nie tak. Skontaktuj się z administratorem.');
                    }
                });
        } else {
            form.setError('captcha', {message: t('register.notifications.captcha')});
        }
    }

    function ErrorLog({field}: {field: string}): React.ReactElement {

        const error = form.formState.errors[field]?.message;

        if (error) {
            return (
                <div className={'error-field'}>{String(error)}</div>
            );
        }

        return <></>;
    }

    if (sendState){
        return <h1 style={{textAlign: 'center', marginTop: '200px'}} >{t('register.notifications.success')}</h1>
    }

    return(
        <div className={'body'} >
            <ChangeLanguage />

            <div className={'register-form'} >
                <button className={'back'} type={'button'} onClick={() => window.history.back()} ><i className={'fas fa-times'} /></button>
                <h1>{t('register.title')}:</h1>

                <form onSubmit={form.handleSubmit(send)} >
                    <div className={'field'} >
                        <span>
                            {t('register.shopping-before')}
                        </span>
                        <span>
                            <ErrorLog field={'shoppingBefore'} />
                            {t('register.yes')} <input type={'radio'} value={'1'} {...form.register('shoppingBefore', {required: t('register.required.select-option')})} /> {t('register.no')} <input type={'radio'} value={'0'} {...form.register('shoppingBefore', {required: t('register.required.select-option')})} />
                        </span>
                    </div>
                    <div className={'field'} >
                        <span>
                            {t('register.company-name')}:
                        </span>
                        <span>
                            <ErrorLog field={'companyName'} />
                            <input {...form.register('companyName', {required: t('register.required.company-name')})} />
                        </span>
                    </div>

                    <h2>{t('register.company-address')}:</h2>

                    <div className={'field'} >
                        <span>
                            {t('register.street')}:
                        </span>
                        <span>
                            <ErrorLog field={'address'} />
                            <input {...form.register('address', {required: t('register.required.address')})} />
                        </span>
                    </div>
                    <div className={'field postal-code'} >
                        <span>
                            {t('register.postal-code')}:
                        </span>
                        <span>
                            <ErrorLog field={'postalCode'} />
                            <input {...form.register('postalCode', {required: t('register.required.postal-code')})} />
                        </span>

                        <span>
                            {t('register.city')}:
                        </span>
                        <span>
                            <ErrorLog field={'city'} />
                            <input {...form.register('city', {required: t('register.required.city')})} />
                        </span>
                    </div>

                    {i18n.language === 'pl-PL' ?

                        <div className={'field'} >
                            <span>
                                Województwo:
                            </span>
                            <span>
                                <ErrorLog field={'voivodeship'} />
                                <select defaultValue={''} {...form.register('voivodeship', {required: 'Podaj województwo'})} >
                                    <option value={''} disabled={true} >-- Wybierz województwo</option>
                                    {voivodeships.map((vo: string, key: number) => {
                                        return <option value={vo} key={key} >{vo}</option>;
                                    })}
                                </select>
                            </span>
                        </div>

                        : null}
                    <div className={'field nip'} >
                        <span>
                            {t('register.nip')}:
                        </span>
                        <span>
                            <ErrorLog field={'nip'} />
                            <input {...form.register('nip', {required: t('register.required.nip')})} />
                        </span>
                        {i18n.language === 'pl-PL' ?

                        <>
                            <span>
                                Numer REGON:
                            </span>
                                <span>
                                <input {...form.register('regon')} />
                            </span>
                        </>

                            : null}
                    </div>
                    <div className={'field'} >
                        <span>
                            {t('register.www')}:
                        </span>
                        <span>
                            <input {...form.register('site')} />
                        </span>
                    </div>
                    <div className={'field phone'} >
                        <span>
                             {t('register.contact-person')}:
                        </span>
                        <span>
                            <ErrorLog field={'contactPerson'} />
                            <input {...form.register('contactPerson', {required: t('register.required.contact-person')})} />
                        </span>
                        <span>
                            {t('register.phone')}:
                        </span>
                        <span>
                            <ErrorLog field={'phone'} />
                            <input {...form.register('phone', {required: t('register.required.phone')})} />
                        </span>
                    </div>
                    <div className={'field'} >
                        <span>
                            {t('register.email')}:
                        </span>
                        <span>
                            <ErrorLog field={'emailPerson'} />
                            <input type={'email'} {...form.register('emailPerson', {required: t('register.required.email')})} />
                        </span>
                    </div>
                    <div className={'field categories'} >
                        <span>
                            {t('register.category')}:
                        </span>
                        <span className={'checkboxes'} >
                            <ErrorLog field={'categories'} />
                            <div>
                                {t('register.categories.office')} <input type={'checkbox'} value={t('register.categories.office')} {...form.register('categories', {required: t('register.required.category')})} />
                            </div>
                            <div>
                                {t('register.categories.school')} <input type={'checkbox'} value={t('register.categories.school')} {...form.register('categories', {required:  t('register.required.category')})} />
                            </div>
                            <div>
                                {t('register.categories.toys')} <input type={'checkbox'} value={t('register.categories.toys')} {...form.register('categories', {required:  t('register.required.category')})} />
                            </div>
                            <div>
                                {t('register.categories.baby')} <input type={'checkbox'} value={t('register.categories.baby')} {...form.register('categories', {required:  t('register.required.category')})} />
                            </div>
                            <div>
                                {t('register.categories.animals')} <input type={'checkbox'} value={t('register.categories.animals')} {...form.register('categories', {required:  t('register.required.category')})} />
                            </div>
                            <div>
                                {t('register.categories.other')} <input type={'checkbox'} value={t('register.categories.other')} {...form.register('categories', {required:  t('register.required.category')})} />
                            </div>
                            {(form.watch('categories') || []).includes(t('register.categories.other')) ?
                                <div className={'category-text'} >
                                    <ErrorLog field={'categoryText'} />
                                    <input {...form.register('categoryText', {required: t('register.required.category')})} placeholder={t('register.name-of-category')} />
                                </div>
                                : null}

                        </span>
                    </div>
                    <div className={'field companyType'} >
                        <span>
                            {t('register.business-type')}:
                        </span>
                        <span>
                            <ErrorLog field={'companyType'} />
                            <select defaultValue={''} {...form.register('companyType', {required: t('register.other-business')})} >
                                <option value={''} disabled={true} >-- {t('register.business.select')}</option>
                                <option>{t('register.business.shop')}</option>
                                <option>{t('register.business.wholesale')}</option>
                                <option>{t('register.business.education')}</option>
                                <option>{t('register.business.office')}</option>
                                <option>{t('register.business.other')}</option>
                            </select>
                        </span>

                        {form.watch('companyType') == t('register.business.other') ?

                            <div className={'category-text'} >
                                <ErrorLog field={'companyTypeText'} />
                                <input {...form.register('companyTypeText', {required: t('register.other-business')})} />
                            </div>

                            : null}

                    </div>
                    <div className={'field'} >
                        <span>
                            {t('register.year-company')}:
                        </span>
                        <span>
                            <input {...form.register('companyDate')} />
                        </span>
                    </div>
                    <div className={'field comments'} >
                        <span>
                            {t('register.other-information')}:
                        </span>
                        <span>
                            <textarea {...form.register('comments')} ></textarea>
                        </span>
                    </div>


                    <div className={'reg'} >
                        <h2>{t('register.checkboxes-title')}:</h2>

                        <div>
                            <input type={'checkbox'} required={true} /> {t('register.checkboxes.first')} <a href={'https://b2b.euro-trade.pl/politykaprywatnosci'} target={'_blank'} >{t('register.checkboxes.link')}</a>.
                        </div>

                        <div>
                            <input type={'checkbox'} required={true} />  {t('register.checkboxes.second')}
                        </div>

                        <div>
                            <input type={'checkbox'} required={true} />  {t('register.checkboxes.third')}
                        </div>

                        <div>
                            <input type={'checkbox'} required={true} /> {t('register.checkboxes.fourth')}
                        </div>

                        <div>
                            {t('register.checkboxes.desc')}
                        </div>
                    </div>

                    <ErrorLog field={'captcha'} />

                    <ReCAPTCHA sitekey={'6Lf6soMrAAAAAPS7mEF8I8mwGa6qu1yYzvpChfBJ'} onChange={(v) => {
                        setCaptcha(true);
                    }} />

                    <div className={'button'} >
                        <button className={'btn red'} type={'button'} onClick={() => window.history.back()} >{t('register.back')}</button>
                        <button className={'btn'} type={'submit'} >{t('register.send')}</button>
                    </div>

                </form>
            </div>
        </div>
    );
}